/*
 * Animation for the Global Transloading's location map
 */
raymont.mapTransloading = function(mapTransloading, locale) {

    var svg = $(mapTransloading.getSVGDocument().documentElement),
        mapContents = $('.map-content'),
        mapDiv = $('.transloading-locations'),
        autoHeight = mapDiv.find('div').height(),
        montrealContainer = svg.find('#montreal'),
        vancouverContainer = svg.find('#vancouver'),
        princeRupertContainer = svg.find('#princerupert');

    // This array will contains proper urls for the svg in function of the locale.
    var urls = [];
    if(locale == 'en_CA') {
        urls[0] = $('#montreal-url-en').html();
        urls[1] = $('#vancouver-url-en').html();
        urls[2] = $('#prince-rupert-url-en').html();
    } else if(locale == 'fr_CA') {
        urls[0] = $('#montreal-url-fr').html();
        urls[1] = $('#vancouver-url-fr').html();
        urls[2] = $('#prince-rupert-url-fr').html();
    }

    var resetAllPortsSelected = function() {
        svg.find('.portContainerSelected').removeClass('portContainerSelected');
        svg.find('.portNameSelected').removeClass('portNameSelected');
    };

    // sert a quoi finalement ?
    var highlightPort = function(portSelected) {
        portContainerElements = portSelected.find('.st2'); 
        portTextElements = portSelected.find('.st3');
        portContainerElements.each(function(){
            $(this).addClass('portContainerSelected');
        });

        portTextElements.each(function(){
            $(this).addClass('portNameSelected');
        });
        // event.preventDefault();
    };

    montrealContainer.click(function(){
        // resetAllPortsSelected();
        // highlightPort(montrealContainer);
        //  window.open(urls[0], "_self"); 
         location.href = urls[0] ;
    });

    vancouverContainer.click(function(){
        // resetAllPortsSelected();
        // highlightPort(vancouverContainer);
        // window.open(urls[1], "_self");
        location.href = urls[1] ;
    });

    princeRupertContainer.click(function(){
        // resetAllPortsSelected();
        // highlightPort(princeRupertContainer);
        // window.open(urls[2], "_self");
        location.href = urls[2] ;

    });
};